import React, { useState } from 'react';
import './styles.css';
import closedEye from '../../assets/icons/hide.png';
import openedEye from '../../assets/icons/show.png';

function HideTextInput({
  label, placeholder='', value, setValue, warningMessage, disabled=false, forgot=false, forgotNav=()=>{}, ref=null,
}) {
  const [hidden, setHidden] = useState(true);

  const togglePasswordVisibility = () => setHidden(!hidden);

  return (
    <div className="text-input-component" ref={ref}>
      <div className="label-container">
        <p
          className="label"
        >
          {label}
        </p>
        {forgot && (
          <p className="forgot" onClick={forgotNav} role="button" tabIndex={0} onKeyDown={(e) => e.key === 'Enter' && forgotNav()}>
            Esqueceu sua senha?
          </p>
        )}
      </div>
      <div className="input-container">
        <input
          type={hidden ? 'password' : 'text'}
          className={`input ${warningMessage ? 'invalid' : ''} ${!warningMessage && value ? 'valid' : ''}`}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder={placeholder}
          disabled={disabled}
        />
        <img
          className="eye-icon"
          alt="eye-visibility"
          src={hidden ? closedEye : openedEye}
          onClick={togglePasswordVisibility}
          onKeyDown={(event) => {
            if (event.key === 'Enter' || event.key === ' ') togglePasswordVisibility();
          }}
          role="button"
          tabIndex={0}
        />
      </div>
      <p className="warning-message">{warningMessage}</p>
    </div>
  );
}

export default HideTextInput;
